/* ==========================================================================
   CHIPS GRID - moves the single highlight to the selected chip.

   The highlight is one element per grid, not a background on each chip, so the
   selection appears to slide rather than blink from one place to another.

   WHY IT IS WRITTEN THIS WAY:
     1. Everything is delegated from `document` and re-run from a
        MutationObserver. Dawn's product-info.js REPLACES this markup on every
        variant change, so anything bound to the element itself would die on the
        first click.
     2. The highlight starts hidden and is only shown once it has been placed,
        so it cannot flash at 0,0 before the first measurement.
     3. Measured against the grid's own box, not the page, so it is unaffected
        by scrolling or by where the grid sits.
   ========================================================================== */
(function () {
  'use strict';

  function place(grid, animate) {
    var checked = grid.querySelector('input:checked');
    var hl = grid.querySelector('[data-chip-hl]');
    if (!hl) return;
    if (!checked) { hl.hidden = true; return; }
    var label = checked.nextElementSibling;
    if (!label) { hl.hidden = true; return; }

    var g = grid.getBoundingClientRect();
    var l = label.getBoundingClientRect();
    if (!l.width) { hl.hidden = true; return; }

    if (!animate) hl.style.transition = 'none';
    hl.style.width = l.width + 'px';
    hl.style.height = l.height + 'px';
    hl.style.transform = 'translate(' + (l.left - g.left) + 'px,' + (l.top - g.top) + 'px)';
    hl.hidden = false;
    if (!animate) {
      /* force a reflow so the transition-less move is committed before the
         transition is restored, otherwise the next move does not animate */
      void hl.offsetWidth;
      hl.style.transition = '';
    }
  }

  function placeAll(animate) {
    document.querySelectorAll('[data-chip-grid]').forEach(function (g) {
      place(g, animate);
    });
  }

  document.addEventListener('change', function (e) {
    var grid = e.target.closest && e.target.closest('[data-chip-grid]');
    if (grid) place(grid, true);
  });

  window.addEventListener('resize', function () { placeAll(false); });

  /* Dawn swaps the markup on every variant change; re-place whatever appears.
     COALESCED THROUGH requestAnimationFrame. placeAll reads layout with
     getBoundingClientRect, and the theme editor fires mutations in bursts of
     hundreds; recomputing on each one is wasted work and made the editor
     crawl. One pass per frame is enough. Hardened 29 Aug 2026 alongside the
     dispatch script, which had the same shape and did lock the editor up. */
  var queued = false;
  var mo = new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; placeAll(false); });
  });

  function start() {
    placeAll(false);
    mo.observe(document.body, { childList: true, subtree: true });
    /* Webfonts change chip widths after load, so measure again once they land. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { placeAll(false); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
